import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';

import { Box, Flex, Text, Image, SimpleGrid, List, ListItem } from '@chakra-ui/react';
import { StyledHeading } from '../../sections/CalltoActionSection/styles';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611032&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - strona Google Analytics',
};

export default function GoogleAnalyticsPage(props: Props) {
    const integrationImages = [
        {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611101&ext=.jpeg',
        },
        {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611102&ext=.jpeg',
        },
        {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611103&ext=.jpeg',
        },
        {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611104&ext=.jpeg',
        },
        {
            url: 'https://www.idosell.com/panel/file-gate.php?id=611105&ext=.jpeg',
        },
    ];

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title={<>Integracja IdoSell z Google Analytics 4</>}
                image={heroImage}
                // badgeLabel="SZABLON SKLEPU"
                subTitle="Włącz analitykę swojego sklepu internetowego i zwiększ efektywność działań."
                buttons={[
                    {
                        title: 'Włącz intergację z GA4',
                        href: 'https://pomoc.idosell.com/marketing-i-promocje/integracja-z-google/google-analytics',
                        variant: 'default',
                    },
                ]}
            />

            <Flex
                className="homepage containerIdosellPages"
                direction={'column'}
                gap={{
                    base: 16,
                    md: 24,
                }}
            >
                {/*  */}
                <Box
                    pt={{
                        base: 16,
                        md: 24,
                    }}
                >
                    <StyledHeading>
                        Zintegruj swój sklep z Google Analytics 4 i analizuj dane jak
                        profesjonalista
                    </StyledHeading>
                    <Text
                        textAlign={'center'}
                        fontSize={{
                            base: 'md',
                            md: 'lg',
                        }}
                        mb={8}
                    >
                        Google Analytics 4 (GA4) to zaawansowane narzędzie do analityki
                        internetowej, umożliwiające precyzyjną analizę zachowań użytkowników w ich
                        drodze do konwersji.
                    </Text>
                    <ChakraTilesSection
                        tilesSettings="4x1"
                        tiles={[
                            {
                                title: 'Gotowa integracja',
                                content:
                                    'Szybkie i łatwe połączenie sklepu z najważniejszym narzędziem analitycznym Google.',
                            },
                            {
                                title: 'Automatyczne śledzenie',
                                content:
                                    'Kod GA4 dodawany jest do każdej strony Twojego sklepu bez dodatkowej konfiguracji.',
                            },
                            {
                                title: 'Pełna warstwa danych',
                                content:
                                    'Automatyczne przekazywanie kluczowych zdarzeń, takich jak dodanie do koszyka, zakup czy wyświetlenie produktu.',
                            },
                            {
                                title: 'Lepsza optymalizacja',
                                content:
                                    'Precyzyjna analiza ścieżki zakupowej użytkowników na różnych urządzeniach i platformach.',
                            },
                        ]}
                    />
                </Box>
                {/*  */}

                <SimpleGrid
                    templateColumns="repeat(2, 1fr)"
                    gap="30px"
                    gridTemplateColumns={{
                        sm: 'templateColumns="1fr"',
                        lg: 'repeat(2, 1fr)',
                    }}
                >
                    <Box my="auto">
                        <Text
                            fontSize={{ base: '25px', lg: '34px' }}
                            fontWeight="bold"
                            className="text-wrapper-2"
                            color="#1AAC7A"
                            marginBottom={4}
                        >
                            Wykorzystaj zaawansowane narzędzia do analizy ruchu i zachowań klientów
                        </Text>
                        <Image
                            src={'https://www.idosell.com/panel/file-gate.php?id=611120&ext=.jpg'}
                            w="100%"
                            display={{ base: 'block', lg: 'none' }}
                        />
                        <List className="item-wrapper">
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Text
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Śledzenie zdarzeń
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'25px'}>
                                        GA4 rejestruje każde działanie użytkownika, takie jak
                                        kliknięcia, pobranie plików czy przesłanie formularza,
                                        pozwalając na dokładniejszą analizę interakcji.
                                    </Text>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Analiza ścieżki użytkownika
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Sprawdzaj, jak użytkownicy poruszają się po Twojej stronie i
                                        aplikacji, by skuteczniej optymalizować proces zakupowy.
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Analiza predykcyjna
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        GA4 wykorzystuje sztuczną inteligencję do przewidywania
                                        zachowań użytkowników, np. prawdopodobieństwa konwersji lub
                                        rezygnacji z zakupów.
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Integracja z wieloma platformami
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        Analizuj użytkowników niezależnie od tego, czy korzystają ze
                                        strony internetowej, czy aplikacji mobilnej i twórz spójne
                                        raporty.
                                    </Box>
                                </Flex>
                            </ListItem>
                            <ListItem
                                py={4}
                                className="text"
                                fontSize={{
                                    base: 'md',
                                    lg: 'lg',
                                }}
                                display={'flex'}
                                gap={'30px'}
                            >
                                <Image
                                    src={
                                        'https://www.idosell.com/panel/file-gate.php?id=314306&ext=.png'
                                    }
                                    alt={'Plus tick'}
                                    width={'20px'}
                                    height={'20px'}
                                    marginTop={'5px'}
                                />
                                <Flex flexDirection={'column'}>
                                    <Box
                                        fontSize={'21px'}
                                        lineHeight={'31.5px'}
                                        fontWeight="600"
                                        marginBottom={'5px'}
                                    >
                                        Pełna kontrola nad danymi i prywatnością
                                    </Box>
                                    <Box fontSize={'16px'} lineHeight={'25px'}>
                                        GA4 jest zgodne z RODO i innymi regulacjami dotyczącymi
                                        prywatności, oferując m.in. anonimizację IP i zaawansowane
                                        ustawienia zarządzania danymi.
                                    </Box>
                                </Flex>
                            </ListItem>
                        </List>
                    </Box>

                    <Image
                        src={'https://www.idosell.com/panel/file-gate.php?id=611072&ext=.jpg'}
                        my="auto"
                        ml={'auto'}
                        mr={'auto'}
                        display={{ base: 'none', lg: 'block' }}
                    />
                </SimpleGrid>
                {/*  */}
                <SectionWithPlusTick
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    ctaButton={{
                        label: 'Włącz Reklamy Google od IdoSell',
                        href: 'https://www.idosell.com/pl/reklamy-google-od-idosell/',
                    }}
                    imageResponsive={{
                        md: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611073&ext=.jpg',
                            alt: 'Zdjęcie Pani z założonymi rękami',
                        },
                        base: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611078&ext=.png',
                            alt: 'Zdjęcie Pani z założonymi rękami',
                        },
                    }}
                    type="tick"
                    tickItem={[
                        {
                            title: 'Śledź każdy krok klienta na drodze do zakupu',
                        },
                        {
                            title: 'Analizuj ścieżki konwersji, interakcje z reklamami i zachowania w Twoim sklepie',
                        },
                        {
                            title: 'Korzystaj z zaawansowanych raportów kampanii Google Ads',
                        },
                        {
                            title: 'Podejmuj decyzje biznesowe dotyczące oferty produktowej',
                        },
                        {
                            title: 'Optymalizuj sklep internetowy oraz aktualizuj swoją strategię marketingową',
                        },
                    ]}
                />
                {/*  */}

                <Flex
                    direction={'column'}
                    alignItems={'center'}
                    gap={4}
                    textAlign={'center'}
                    mt={16}
                >
                    <StyledHeading>
                        Wszystkie najważniejsze integracje Google dostępne w IdoSell
                    </StyledHeading>
                    <Flex
                        mt={8}
                        flexWrap={'wrap'}
                        gap={4}
                        justifyContent={'center'}
                        alignItems="center"
                        rowGap={8}
                        columnGap={10}
                    >
                        {integrationImages.map((image, index) => (
                            <Image
                                key={index}
                                src={image.url}
                                alt={`Integracja Google ${index}`}
                                width={{
                                    base: '140px',
                                    md: '180px',
                                }}
                                height={{
                                    base: 'auto',
                                    md: 'auto',
                                }}
                            />
                        ))}
                    </Flex>
                </Flex>

                {/*  */}

                <ContactSection
                    pb={{
                        base: 16,
                        md: 24,
                    }}
                />
            </Flex>
        </ThemeProvider>
    );
}
